import styled from '@emotion/styled';
import { colors, fontSizes, fontWeights, gutterSizes, lineHeights } from '@gumtree/ui-library/src/base/theme';

export const AdReviewsWrapper = styled.div`
    background: ${colors.white};
    overflow: hidden;
    width: 100%;
    padding: ${gutterSizes.large40} 0;
    border-top: 1px solid ${colors.newBorder};
`;

export const ReviewsTitle = styled.h2`
    font-size: ${fontSizes.xlarge};
    font-weight: ${fontWeights.bold};
    color: ${colors.bark};
    margin-bottom: ${gutterSizes.base};
`;

export const TopTips = styled.p`
    font-size: ${fontSizes.small};
    color: ${colors.darkGrey};
    margin-bottom: ${gutterSizes.xlarge};
    line-height: ${lineHeights.small};
`;

export const ReviewsList = styled.div`
    margin-top: ${gutterSizes.large};
`;

export const BottomInfo = styled.div`
    display: flex;
    align-items: flex-start;
    gap: ${gutterSizes.base};
    padding: ${gutterSizes.large} 0;
    border-top: 1px solid ${colors.newBorder};
    border-bottom: 1px solid ${colors.newBorder};
`;

export const InfoIcon = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    
    svg {
        width: 16px;
        height: 16px;
    }
`;

export const BottomTips = styled.p`
    font-size: ${fontSizes.smaller};
    color: ${colors.darkGrey};
    margin: 0;
    line-height: 1.4;
`;
